var _jsxFileName = "/runner/_work/smpackages/smpackages/packages/webassets/src/components/Footer/index.tsx",
  _this = this;
import React from 'react';
import AnonFooter from './AnonFooter';
import AuthedFooter from './AuthedFooter';
import { FooterContext } from './SMFooterContext';
var SMFooter = function SMFooter(_ref) {
  var isUserAuthenticated = _ref.isUserAuthenticated,
    lang = _ref.lang,
    domain = _ref.domain,
    subdomain = _ref.subdomain,
    country = _ref.country,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'default' : _ref$variant,
    _ref$showBillingAddre = _ref.showBillingAddress,
    showBillingAddress = _ref$showBillingAddre === void 0 ? false : _ref$showBillingAddre,
    isEUDC = _ref.isEUDC,
    tld = _ref.tld,
    _ref$url = _ref.url,
    url = _ref$url === void 0 ? undefined : _ref$url,
    onetrustBannerEnabled = _ref.onetrustBannerEnabled,
    _ref$makeFooterLinksS = _ref.makeFooterLinksStatic,
    makeFooterLinksStatic = _ref$makeFooterLinksS === void 0 ? false : _ref$makeFooterLinksS;
  return /*#__PURE__*/React.createElement(FooterContext, {
    isUserAuthenticated: isUserAuthenticated,
    lang: lang,
    subdomain: subdomain,
    domain: domain,
    country: country,
    variant: variant,
    showBillingAddress: showBillingAddress,
    isEUDC: isEUDC,
    tld: tld,
    url: url,
    onetrustBannerEnabled: onetrustBannerEnabled,
    makeFooterLinksStatic: makeFooterLinksStatic,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 21,
      columnNumber: 5
    }
  }, !!isUserAuthenticated ? /*#__PURE__*/React.createElement(AuthedFooter, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 37,
      columnNumber: 11
    }
  }) : /*#__PURE__*/React.createElement(AnonFooter, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 40,
      columnNumber: 11
    }
  }));
};
export default SMFooter;
//# sourceMappingURL=index.js.map